import { render, staticRenderFns } from "./region-filter-button-group.vue?vue&type=template&id=67b40898"
import script from "./region-filter-button-group.vue?vue&type=script&lang=js"
export * from "./region-filter-button-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports